import { useEffect, useState } from "react";
import Select, { components }  from "react-select";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import { useTranslation } from "react-i18next";

import HospitalApi from "../../api/hospital";

import login from "../../assets/Backgrounds/login.svg";
import gistLogo from "../../assets/Logos/gist_logo.svg";


export default function HospitalSelection({ }) {
  const [ hospitalsList, setHospitalsList ] = useState([]);

  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const getHospitalsList = async () => {
    const hospitals = await HospitalApi.getHospitalList();
    setHospitalsList(hospitals);
  }

  const selectHospital = (hospital) => {
    saveHospital(hospital);
    navigate(`/login/${hospital.name}`);
  }

  const saveHospital = (hospital) => {
    localStorage.setItem("hospital", JSON.stringify(hospital));
  }

  useEffect(() => {
    getHospitalsList();
  }, [])


  const hospitalOptions = hospitalsList.map((hospital) => ({
    value: hospital,
    label: hospital?.name,
    hospital
  }));

  return (
    <Container>  {/* color={selectedHospital?.color1}> */}
      <GistLogo />
      <Form>
        <Titles>
          <Title>{t("Welcome-Page-Title", "ברוכים הבאים")}</Title>
          <SubTitle
            dangerouslySetInnerHTML={{
              __html: t(
                "Welcome-Page-Subtitle",
                "מערכת ליווי והדרכת<br />מטופלים לטרום ניתוח"
              ),
            }}
          />
        </Titles>
        <DropdownWrapper>
          <Select
            options={hospitalOptions}
            placeholder={t("Select-Hospital", "Choose your hospital")}
            onChange={(selected) =>
              selectHospital(selected.hospital)
            }
            noOptionsMessage={() => t("No-Results", "לא נמצאו תוצאות")}
            styles={{
              control: (base) => ({
                ...base,
                borderRadius: "3rem",
                backgroundColor: "#f02a4c",
                borderColor: "transparent",
                padding: "0.4rem 1rem",
                fontSize: "1rem",
                fontFamily: "inherit",
                cursor: "pointer",
              }),
              placeholder: (base) => ({ ...base, color: "white" }),
              menu: (base) => ({
                ...base,
                borderRadius: "1rem",
                zIndex: 1000,
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isFocused ? "#fce4ec" : "white",
                color: "#f02a4c",
              }),
            }}
          />
        </DropdownWrapper>
      </Form>
    </Container>
  )
}

const Container = styled.div`
  background-image: url("${login}");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-color: ${({ color }) => color || "transparent"};
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  direction: rtl;
  font-family: "Abraham";
  position: relative;

  @media (max-width: 768px) {
    align-items: center;
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: fit-content;
  align-items: center;
  direction: ltr;
  border-radius: 50px;
  background-color: rgba(255, 255, 255, 0.5);
  padding: 4rem;
  margin-right: 8rem;

  @media (max-width: 768px) {
    margin: 0;
    padding: 2rem;
  }
`;


const DropdownWrapper = styled.div`
  margin-top: 2rem;
  width: 100%;
  max-width: 300px;
`;


const Titles = styled.div`
  text-align: center;
  width: 100%;
`;

const Title = styled.h1`
  font-size: 2.25rem;
  margin: 0;
`;

const SubTitle = styled.p`
  font-size: 1.5rem;
  margin-top: 0.5rem;
`;

const GistLogo = styled.img.attrs({ src: gistLogo })`
  position: absolute;
  height: 78px;
  top: 24px;
  left: 24px;

  @media (max-width: 480px) {
    height: 55px;
    top: 16px;
    left: 16px;
  }
`;

const HospitalLogo = styled.img`
  position: absolute;
  height: 78px;
  top: 24px;
  right: 24px;

  @media (max-width: 480px) {
    height: 55px;
    top: 16px;
    right: 16px;
  }
`;